module.exports = __webpack_public_path__ + "img/cert11.8bf66be9.png";